import { createSelector } from "reselect";
import { map } from 'lib/imports/lodash';

import fletcherSelectors from 'store/fletcher/selectors';
import NewsletterSelectors from 'store/entities/Newsletter/selectors';

export default {

	// TODO GIS-4551 CHECK THIS WORKS OK
	getNewsletters: createSelector(state => state, fletcherSelectors.isNewslettersFetched, fletcherSelectors.isFocusFetched,
		(state, isNewslettersFetched, isFocusFetched) => {
			if (!isNewslettersFetched || !isFocusFetched) return null;
			return map(NewsletterSelectors.getInstances(state), newsletter => ({
				...newsletter.ref,
				id: newsletter.id,
				name: newsletter.name,
				emailLists: newsletter.emailLists.all().toRefArray(),
				tags: newsletter.tags.all().toRefArray(),
				feeds: newsletter.feeds.all().toRefArray(),
				enabled: newsletter.enabled,
				type: newsletter.type,
				description: newsletter.description,
				subject: newsletter.subject,
				emails: newsletter.emails,
				send_to: newsletter.send_to,
				send_configuration_json: newsletter.send_configuration_json,
				user_edited: newsletter.user_edited,
				user_created: newsletter.user_created,
				inserted_at: newsletter.inserted_at,
				edited_at: newsletter.edited_at
			}));
		})
};
